import { FileImageOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { Button, Card, Drawer, Empty, Flex, Form, Input, Space } from 'antd';
import React, { useState } from 'react';

const ProductDataDisplay = ({ productData }) => {
  const [selectedField, setSelectedField] = useState({});
  const [open, setOpen] = useState(false);

  const handleShowDetails = (item) => {
    setSelectedField(item);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  if (!productData || productData.length === 0) {
    return (
      <div style={{ padding: '24px' }}>
        <Empty
          description={
            <div style={{ maxWidth: 500, margin: '0 auto', textAlign: 'left' }}>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 500,
                  marginBottom: 12,
                  textAlign: 'center',
                }}
              >
                Aucune donnée disponible
              </div>
              <div style={{ lineHeight: 1.6, color: 'rgba(0, 0, 0, 0.65)' }}>
                Pour afficher les attributs marketplace de ce produit, vous
                devez suivre ces étapes :
                <ol style={{ marginTop: 12, paddingLeft: 20 }}>
                  <li style={{ marginBottom: 8 }}>
                    <strong>Configurer un mapping</strong> pour la catégorie
                    marketplace et le store associés à ce produit
                  </li>
                  <li style={{ marginBottom: 8 }}>
                    <strong>Transformer les données brutes</strong> du produit
                    en utilisant le mapping configuré
                  </li>
                </ol>
                <div
                  style={{
                    marginTop: 16,
                    padding: 12,
                    background: '#f0f5ff',
                    borderLeft: '3px solid #1890ff',
                    borderRadius: 4,
                  }}
                >
                  💡 Une fois le mapping configuré et la transformation
                  effectuée, les attributs du produit s&apos;afficheront ici et
                  pourront être envoyés vers la marketplace.
                </div>
              </div>
            </div>
          }
        />
      </div>
    );
  }

  // Fonction pour vérifier si une valeur est une URL d'image/média
  const isMediaUrl = (value) => {
    if (typeof value !== 'string') return false;

    // Vérifier si c'est une URL
    const urlPattern = /^(https?:\/\/)/i;
    if (!urlPattern.test(value)) return false;

    // Vérifier si c'est une image ou un média
    const mediaExtensions =
      /\.(jpg|jpeg|png|gif|bmp|webp|svg|mp4|avi|mov|wmv|flv|pdf)$/i;
    return (
      mediaExtensions.test(value) ||
      value.includes('/products/') ||
      value.includes('/media/')
    );
  };

  // Séparer les données en médias et attributs
  const mediaData = productData.filter((item) => isMediaUrl(item.value));
  const attributeData = productData.filter((item) => !isMediaUrl(item.value));

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Card
        title="Attributs marketplace"
        bordered
        style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        bodyStyle={{
          flex: 1,
          overflow: 'auto',
          padding: '24px',
        }}
      >
        <Form layout="vertical">
          {/* Afficher d'abord les attributs non-médias */}
          {attributeData.map((item, index) => (
            <Form.Item
              key={`attribute-${index}`}
              label={item.label || item.name || `Attribut ${index + 1}`}
            >
              <Space.Compact style={{ width: '100%' }}>
                {Array.isArray(item.value) ? (
                  <Input.TextArea
                    value={JSON.stringify(item.value, null, 2)}
                    disabled
                    rows={3}
                    style={{ width: '75%' }}
                  />
                ) : typeof item.value === 'object' && item.value !== null ? (
                  <Input.TextArea
                    value={JSON.stringify(item.value, null, 2)}
                    disabled
                    rows={3}
                    style={{ width: '75%' }}
                  />
                ) : (
                  <Input
                    value={item.value_label ?? item.value ?? '-'}
                    disabled
                    style={{ width: '75%' }}
                  />
                )}
                <Button
                  icon={<InfoCircleOutlined />}
                  onClick={() => handleShowDetails(item)}
                  style={{ width: '25%' }}
                >
                  Détails
                </Button>
              </Space.Compact>
            </Form.Item>
          ))}

          {/* Afficher ensuite les médias avec leur affichage spécial */}
          {mediaData.map((item, index) => (
            <Form.Item
              key={`media-${index}`}
              label={
                <Space>
                  <span>{item.name || item.code || `Média ${index + 1}`}</span>
                  <Button
                    size="small"
                    icon={<FileImageOutlined />}
                    onClick={() => window.open(item.value, '_blank')}
                    disabled={!item.value}
                  >
                    Consulter le média
                  </Button>
                </Space>
              }
            >
              <Space.Compact style={{ width: '100%' }}>
                <Input
                  value={item.value || '-'}
                  disabled
                  style={{ width: '75%' }}
                />
                <Button
                  icon={<InfoCircleOutlined />}
                  onClick={() => handleShowDetails(item)}
                  style={{ width: '25%' }}
                >
                  Détails
                </Button>
              </Space.Compact>
            </Form.Item>
          ))}
        </Form>
      </Card>

      <Drawer
        title="Détails de l'attribut"
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        open={open}
        width={500}
      >
        <Flex vertical gap={16}>
          <div>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Code</div>
            <Input value={selectedField?.code || '-'} disabled />
          </div>
          <div>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>Nom</div>
            <Input value={selectedField?.name || '-'} disabled />
          </div>
          <div>
            <div style={{ marginBottom: 8, fontWeight: 500 }}>
              Valeur (Code)
            </div>
            {Array.isArray(selectedField?.value) ||
            (typeof selectedField?.value === 'object' &&
              selectedField?.value !== null) ? (
              <Input.TextArea
                value={JSON.stringify(selectedField?.value, null, 2)}
                disabled
                rows={6}
              />
            ) : (
              <Input
                value={
                  selectedField?.value !== null &&
                  selectedField?.value !== undefined
                    ? String(selectedField?.value)
                    : '-'
                }
                disabled
              />
            )}
          </div>
          {selectedField?.value_label !== null &&
            selectedField?.value_label !== undefined && (
              <div>
                <div style={{ marginBottom: 8, fontWeight: 500 }}>
                  Valeur (Label)
                </div>
                <Input value={String(selectedField.value_label)} disabled />
              </div>
            )}
        </Flex>
      </Drawer>
    </div>
  );
};

export default ProductDataDisplay;
